<template>

  <header class="flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat h-screen bg-[#5c5c5e]">
    <div class="w-full">
      <div class="pb-5 flex flex-col items-center max-h-full">
        <img class="max-h-full object-contain w-9/12 md:8/12 lg:w-4/12" src="@/assets/logo.png"/>
      </div>

      <h1 class="font-bold text-lg md:text-2xl lg:text-3xl w-full text-center text-white mt-5 pt-5">MUCHAS GRACIAS POR INSCRIBIRSE A CAPER SHOW</h1>

      <div class="flex flex-col text-lg md:text-xl lg:text-3xl text-center text-white mt-10 ">
        <span class="font-semibold">¡ATENCIÓN!</span>
        <span class="font-semibold mb-10">ESTE AÑO CAMBIAMOS EL HORARIO</span>
        <span class="text-[#ffcd00]">
          <ul>
            <li>MIÉRCOLES 7 DE OCTUBRE 10:00hs A 19:00hs</li>
            <li>JUEVES 8 DE OCTUBRE 10:00hs A 19:00hs</li>
            <li>VIERNES 9 DE OCTUBRE DE 10:00hs A 16:00hs</li>
          </ul>

        </span>
        <span class="font-semibold mt-8 py-4">¡TE ESPERAMOS!</span>
      </div>


    </div>
  </header>

</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  components: {
  },
});
</script>